import { render, staticRenderFns } from "./car-life.vue?vue&type=template&id=9dcb9c7a&scoped=true"
import script from "./car-life.vue?vue&type=script&lang=js"
export * from "./car-life.vue?vue&type=script&lang=js"
import style0 from "./car-life.vue?vue&type=style&index=0&id=9dcb9c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcb9c7a",
  null
  
)

export default component.exports